import { User } from '~/src/queries/types/user';

let datadogRumPromise: Promise<typeof import('@datadog/browser-rum')> | null = null;

const getDatadogRum = async () => {
  if (!datadogRumPromise) {
    datadogRumPromise = import('@datadog/browser-rum');
  }
  return (await datadogRumPromise).datadogRum;
};

export const DataDog = {
  setup: async (samplingRate: number, replaySamplingRate: number) => {
    DataDog.setup = () => Promise.resolve();
    const datadogRum = await getDatadogRum();

    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'ecom',
      env: process.env.NEXT_PUBLIC_APP_TIER,
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      sessionSampleRate: process.env.NODE_ENV === 'production' ? samplingRate : 100,
      sessionReplaySampleRate: process.env.NODE_ENV === 'production' ? replaySamplingRate : 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      enablePrivacyForActionName: true,
    });
  },
  setUser: async (user: User) => {
    const datadogRum = await getDatadogRum();
    datadogRum.setUser({
      id: user.id,
      email: user.email,
    });
  },
};
